import React from 'react';

const ToolBoxIcon = ({
  width = '16',
  height = '16',
  fill = 'none',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill={fill}
    {...props}
  >
    <g clipPath="url(#clip0_2642_1456)">
      <path
        d="M14.1721 5.8877H2.44395C2.24954 5.8877 2.0631 5.96492 1.92563 6.10239C1.78816 6.23985 1.71094 6.4263 1.71094 6.6207V13.9508C1.71094 14.1452 1.78816 14.3316 1.92563 14.4691C2.0631 14.6066 2.24954 14.6838 2.44395 14.6838H14.1721C14.3665 14.6838 14.5529 14.6066 14.6904 14.4691C14.8279 14.3316 14.9051 14.1452 14.9051 13.9508V6.6207C14.9051 6.4263 14.8279 6.23985 14.6904 6.10239C14.5529 5.96492 14.3665 5.8877 14.1721 5.8877Z"
        stroke="#222222"
        strokeWidth="1.46602"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.64453 5.88779V5.15478C4.64453 4.18276 5.03067 3.25054 5.718 2.56321C6.40532 1.87588 7.33754 1.48975 8.30957 1.48975C9.2816 1.48975 10.2138 1.87588 10.9011 2.56321C11.5885 3.25054 11.9746 4.18276 11.9746 5.15478V5.88779"
        stroke="#222222"
        strokeWidth="1.46602"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.71094 9.55273H14.9051"
        stroke="#222222"
        strokeWidth="1.46602"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.30859 9.55273V11.7518"
        stroke="#222222"
        strokeWidth="1.46602"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2642_1456">
        <rect
          width="14.6602"
          height="14.6602"
          fill="white"
          transform="translate(0.978516 0.756836)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default ToolBoxIcon;
